import { ResultType } from './experimentResults';

export type ArtifactsGroupBy = 'model' | 'result_name';
export interface ArtifactResultsConfig {
  resultTypes?: string[];
  resultNames?: string[];
  filterArtifactsWithTsmOnly?: boolean;
  groupBy?: ArtifactsGroupBy[];
}

export enum ResultName {
  CellTyping = 'cell_typing',
  GenericPipsRun = 'generic_pips_run',
  FilteredCells = 'filtered_cells',
}

export const BinaryClassifierConfig: ArtifactResultsConfig = {
  resultTypes: [ResultType.MarkersProbabilities],
  filterArtifactsWithTsmOnly: false,
  groupBy: ['model'],
};

export const AreaConfig: ArtifactResultsConfig = {
  resultTypes: [ResultType.SlideInferenceAreas],
  filterArtifactsWithTsmOnly: true,
  groupBy: ['model'],
};

export const CellConfig: ArtifactResultsConfig = {
  resultTypes: [ResultType.SlideInferencePoints],
  filterArtifactsWithTsmOnly: true,
  groupBy: ['model'],
};

export const DefectConfig: ArtifactResultsConfig = {
  resultTypes: [ResultType.SlideInferenceDefects],
  filterArtifactsWithTsmOnly: true,
  groupBy: ['model'],
};

export const TlsConfig: ArtifactResultsConfig = {
  resultTypes: [ResultType.SlideInferenceTls],
  filterArtifactsWithTsmOnly: true,
  groupBy: ['model'],
};

export const ClassificationIntensityConfig: ArtifactResultsConfig = {
  resultTypes: [ResultType.SlideInferenceClassificationIntensity],
  filterArtifactsWithTsmOnly: false,
  groupBy: ['model'],
};

export const ClassificationConfig: ArtifactResultsConfig = {
  resultTypes: [ResultType.SlideInferenceClassification],
  filterArtifactsWithTsmOnly: false,
  groupBy: ['model'],
};

export const CellAttributesTableConfig: ArtifactResultsConfig = {
  resultTypes: [ResultType.SlideCellAttributesTable],
  filterArtifactsWithTsmOnly: false,
  groupBy: ['result_name'],
};

export const CellSegmentationConfig: ArtifactResultsConfig = {
  resultTypes: [ResultType.SlideInferenceCellSegmentation, ResultType.SlideInferenceNucleiSegmentation],
  filterArtifactsWithTsmOnly: false,
  groupBy: ['model'],
};

export const CellTypingConfig: ArtifactResultsConfig = {
  resultTypes: [ResultType.PipsCellsTable],
  filterArtifactsWithTsmOnly: false,
  resultNames: [ResultName.CellTyping],
  groupBy: ['result_name'],
};

export const PipsResultsConfig: ArtifactResultsConfig = {
  resultTypes: [ResultType.PipsCellsTable],
  filterArtifactsWithTsmOnly: false,
  groupBy: ['result_name'],
};

export const PipsAreaInstancesConfig: ArtifactResultsConfig = {
  resultTypes: [ResultType.PipsAreaInstancesTable],
  filterArtifactsWithTsmOnly: false,
  groupBy: ['result_name'],
};

export const CellQuantificationConfig: ArtifactResultsConfig = {
  resultTypes: [ResultType.CellQuantification],
  filterArtifactsWithTsmOnly: false,
  groupBy: ['result_name'],
};

export const AreaQuantificationConfig: ArtifactResultsConfig = {
  resultTypes: [ResultType.AreaQuantification],
  filterArtifactsWithTsmOnly: false,
  groupBy: ['result_name'],
};

export const SlideSegmentationsTableConfig: ArtifactResultsConfig = {
  resultTypes: [ResultType.SlideSegmentationsTable],
  filterArtifactsWithTsmOnly: false,
  groupBy: ['result_name'],
};

export const SlideDetectionsTableConfig: ArtifactResultsConfig = {
  resultTypes: [ResultType.SlideDetectionsTable],
  filterArtifactsWithTsmOnly: false,
  groupBy: ['result_name'],
};

export enum AttributesTable {
  AreaTable = 'area_table',
  CellTable = 'cell_table',
  DetectionsTable = 'detections_table',
}

export const slideResultToAttributesTable: { [key in ResultType]?: AttributesTable } = {
  [ResultType.MarkersProbabilities]: AttributesTable.CellTable,
  [ResultType.SlideCellAttributesTable]: AttributesTable.CellTable,
  [ResultType.SlideInferenceCellSegmentation]: AttributesTable.CellTable,
  [ResultType.SlideInferenceNucleiSegmentation]: AttributesTable.CellTable,
  [ResultType.PipsCellsTable]: AttributesTable.CellTable,
  [ResultType.PipsAreaInstancesTable]: AttributesTable.AreaTable,
  [ResultType.CellQuantification]: AttributesTable.CellTable,
  [ResultType.AreaQuantification]: AttributesTable.AreaTable,
  [ResultType.SlideSegmentationsTable]: AttributesTable.AreaTable,
  [ResultType.SlideDetectionsTable]: AttributesTable.DetectionsTable,
};
